import { Facilities, Facility, useAuth } from '@app/shared';
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { ReportsView } from '../ReportsView';
import { useLocation } from 'react-use';
import { DashboardLayout } from '../../layouts';
import { OrganizationDropdown } from '../../shared/OrganizationDropdown';
import { ScreenlineMap } from './ScreenlineMap';
import { OrgReportContext } from '../reportHelpers';


export const ScreenlineMapReportPage: React.FC = () => {
    const location = useLocation();
    const { currentOrganizationId, setCurrentOrganizationId, } = useAuth();
    const [facilities, setFacilities] = useState<Array<Facility>>([]);
    const [isLoading, setIsLoading] = useState(true);
    const changeOrgs = async (newOrgId: string) => {
        setCurrentOrganizationId(newOrgId);
    };
    useEffect(() => {
        const facilitiesFromState = (location.state?.facilities || []) as Array<Facility>;

        if (facilitiesFromState.length > 0) {
            setFacilities(facilitiesFromState);
            setIsLoading(false);
        } else if (currentOrganizationId) {
            setIsLoading(true);
            Facilities.getActiveByOrganizationId(currentOrganizationId)
                .then(fetchedFacilities => {
                    setFacilities(fetchedFacilities || []);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Failed to fetch facilities:', error);
                    setFacilities([]);
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }
    }, [currentOrganizationId, location.state]);
    const selectedFacility = facilities.find(facility => facility.devices && facility.devices.length > 0);


    return isLoading ? null : (<DashboardLayout leftChildren={<OrganizationDropdown onChange={changeOrgs} initOrgId={currentOrganizationId} />} centerChildren="Organization Event Reports" >
        <OrgReportContext.Provider value={{ facilities }} >
            <ReportsView onChange={() => { }} facility={selectedFacility} initialReportKey={ScreenlineMap.key} />
        </OrgReportContext.Provider>
    </DashboardLayout>
    );
}
